import { useEffect, useState } from "react";
import {
  Text,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Textarea,
  useToast,
  Select
} from "@chakra-ui/react";
import axiosInstance from "../../libs/axiosService";
import { useNavigate, useParams } from "react-router-dom";
import { formatTimestamp } from "../../libs/functions";
import LoadingBox from "../shared/Loading";

const AllWithdrawRequests = () => {
  const [loading, setLoading] = useState(true);
  const [withdraws, setWithdraws] = useState([]);
  const [withdrawStatus, setWithdrawStatus] = useState(""); // Add this line
  const [requestDescription, setRequestDescription] = useState(""); // Add this line
  const navigate = useNavigate();
  const { isOpen: isWithdrawOpen, onOpen: onWithdrawOpen, onClose: onWithdrawClose } = useDisclosure();
  const { isOpen: isWithdrawDetailOpen, onOpen: onWithdrawDetailOpen, onClose: onWithdrawDetailClose } = useDisclosure();
  const [withDrawDetails, setWithdrawDetails] = useState({});
  const { id } = useParams();
  const toast = useToast();
  useEffect(() => {

    fetchWithdrawRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchWithdrawRequest = async () => {
    try {
      const response = await axiosInstance.get("/admin-withdraws");
      const withdrawData = response.data.withdraws;
      setLoading(false);
      setWithdraws(withdrawData);

    } catch (error) {
      console.error("Error fetching projects:", error);
      setLoading(false);
    }
  };


  const submitWithdrawRequest = async () => {
    try {
      const response = await axiosInstance.put("/withdraw/" + withDrawDetails?._id, {
        approval_status: withdrawStatus,
        response_message: requestDescription
      });

      if (response.status === 200) {
        fetchWithdrawRequest();
        setWithdrawStatus("");
        setRequestDescription("");
        onWithdrawClose();
      }
    } catch (error) {
      console.error("Error submitting withdraw request:", error);
      toast({
        title: "Error",
        description: error.response.data || "Failed to submit withdraw request.",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
    }
  };

  const onWithdrawDetailCloseFtn = () => {
    onWithdrawDetailClose();
    setWithdrawDetails({});
  };

  if (loading) {
    return <LoadingBox />;
  }

  return (
    <>


      <Box borderWidth="1px" borderRadius="lg" overflow="hidden" w={"100%"} p={5} m="auto">

        <Table variant="simple" mt={3}>
          <TableCaption color={"#e98429"} fontWeight={600}>Withdraw Requests That You've Received Through Creators.</TableCaption>
          <Thead>
            <Tr>
              <Th>Requested Amount</Th>
              <Th>Status</Th>
              <Th>Project</Th>
              <Th>User</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {withdraws.map((withdraw) => (
              <Tr key={withdraw._id}>
                <Td>${withdraw.amount?.toLocaleString()}</Td>
                <Td>{
                  withdraw.approval_status === "approved"
                    ? <span className="published">
                      Approved
                    </span>
                    :
                    withdraw.approval_status === "rejected"
                      ? <span className="unpublished">
                        Rejected
                      </span>
                      :
                      withdraw.approval_status === "on-hold"
                        ? <span className="onholdStatus">
                          On-Hold
                        </span>
                        :
                        <span className="pendingStatus">
                          Pending
                        </span>
                }</Td>
                <Td>{withdraw?.project?.basic?.title}</Td>
                <Td>{withdraw?.user?.name}</Td>

                <Td>
                  <Button colorScheme="teal" size={"xs"}
                    mr={2}
                    onClick={() => {
                      onWithdrawDetailOpen();
                      setWithdrawDetails(withdraw);
                    }}
                  >Details</Button>
                  <Button colorScheme="orange" size={"xs"}
                    onClick={() => {
                      onWithdrawOpen();
                      setWithdrawStatus(withdraw.approval_status);
                      setRequestDescription(withdraw.response_message);
                      setWithdrawDetails(withdraw);
                    }}
                  >Response</Button>
                </Td>


              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>


      {/* Modal for submitting withdraw request */}
      <Modal isOpen={isWithdrawOpen} onClose={onWithdrawClose} size={"xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Reponse to Withdraw Request</ModalHeader>
          <ModalCloseButton />
          <ModalBody>


            <FormControl>
              <FormLabel>Select Status</FormLabel>
              <Select placeholder="Select the status"
                value={withdrawStatus}
                onChange={(e) => {
                  setWithdrawStatus(e.target.value);
                }}
              >
                <option value={"pending"}>Pending</option>
                <option value={"on-hold"}>On Hold</option>
                <option value={"approved"}>Approved</option>
                <option value={"rejected"}>Rejected</option>

              </Select>

            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Response Message</FormLabel>
              <Textarea placeholder="Enter the description"
                value={requestDescription}
                onChange={(e) => {
                  setRequestDescription(e.target.value);
                }}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="orange" mr={3} onClick={submitWithdrawRequest}>
              Submit
            </Button>
            <Button onClick={onWithdrawClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal for withdraw request details */}
      <Modal isOpen={isWithdrawDetailOpen} onClose={onWithdrawDetailCloseFtn} size={"xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Withdraw Request Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>

            <Text mt={4} fontSize="lg" fontWeight="bold">
              Basic Details:
            </Text>

            <Box sx={{ ml: 5, mt: 2 }}>
              <Text>
                <b>Requested Amount:</b> ${withDrawDetails?.amount}
              </Text>
              <Text mt={2}>
                <b style={{marginRight: "5px" }}>Status:</b> 
                {
                  withDrawDetails?.approval_status === "approved"
                    ? <span className="published">
                      Approved
                    </span>
                    :
                    withDrawDetails?.approval_status === "rejected"
                      ? <span className="unpublished">
                        Rejected
                      </span>
                      :
                      withDrawDetails?.approval_status === "on-hold"
                        ? <span className="onholdStatus">
                          On-Hold
                        </span>
                        :
                        <span className="pendingStatus">
                          Pending
                        </span>
                }

              </Text>
              <Text mt={2}>
                <b>Requested At:</b> {formatTimestamp(withDrawDetails?.createdAt)}
              </Text>
              <Text mt={2}>
                <b>Request Message:</b> {withDrawDetails?.request_message || 'N/A'}
              </Text>
              <Text mt={2}>
                <b>Response Message:</b> {withDrawDetails?.response_message || 'N/A'}
              </Text>

            </Box>

            <Text mt={4} fontSize="lg" fontWeight="bold">
              User Details:
            </Text>

            <Box sx={{ ml: 5, mt: 2 }}>
              <Text>
                <b>Name:</b> {withDrawDetails?.user?.name}
              </Text>
              <Text mt={2}>
                <b>Email:</b> {withDrawDetails?.user?.email}
              </Text>
            </Box>

            <Text mt={4} fontSize="lg" fontWeight="bold">
              Project Details:
            </Text>
            <Box sx={{ ml: 5, mt: 2 }}>
            <Text>
              <b>Title:</b> {withDrawDetails?.project?.basic?.title}
            </Text>
            <Text mt={2}>
              <b>Category:</b> {withDrawDetails?.project?.basic?.category}
            </Text>
            <Text mt={2}>
              <b>Subcategory:</b> {withDrawDetails?.project?.basic?.subcategory}
            </Text>
            <Text mt={2}>
              <b>Location:</b> {withDrawDetails?.project?.basic?.location}
            </Text>
            <Text mt={2}>
              <b>Subtitle:</b> {withDrawDetails?.project?.basic?.subtitle}
            </Text>
            </Box>

          </ModalBody>
          <ModalFooter>
            <Button onClick={onWithdrawDetailCloseFtn}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>


    </>
  );
};

export default AllWithdrawRequests;
